<style lang="scss" scoped>
button {
    &.loading,
    &.success {
        padding: 13px 25px;
    }
    &:disabled {
        pointer-events: none;
    }
    .checkmark {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 20px;
        margin-left: 15px;

        &::after {
            content: "";
            display: block;
            width: 10px;
            height: 18px;
            margin-top: -10px;
            border: solid #fff;
            border-width: 0 2px 2px 0;
            transform: rotate(45deg);
        }
    }
}
</style>

<template>
    <button data-tc-btn-submit :disabled="loading || disabled" type="submit" @click="$emit('click')" :class="[cls, { loading: loading, success: success }]">
        {{ !loading && !success ? defaultLabel : loading ? loadingLabel : successLabel }}
        <el-loader :loading="loading" class="my-auto ml-16" />
        <div v-show="!loading && success" class="checkmark my-auto ml-16"></div>
        <span v-show="!loading && !success" v-html="svg('arrow-right', 'arrow-right')"></span>
    </button>
</template>

<script>
export default {
    name: "components.forms.el_button",

    props: {
        defaultLabel: { type: String },
        loadingLabel: { type: String },
        successLabel: { type: String },
        loading: { default: false },
        success: { default: false },
        disabled: { default: false },
        cls: { default: "btn btn-accent btn-arrow d-flex justify-content-center" }
    },
    components: {
        ElLoader: () => import(/* webpackChunkName: "elements" */ "./ElLoader")
    }
};
</script>
